// This allows us to load Angular components on legacy server-side pages.
import { HttpClientXsrfModule } from '@angular/common/http';
import {
  ErrorHandler,
  NgModule,
  NgModuleFactoryLoader,
  SystemJsNgModuleLoader,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ROUTES } from '@angular/router';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AuthModule } from '@shared/auth';
import { DatastoreModule } from '@shared/datastore';
import { CustomErrorHandler, TrackingModule } from '@shared/tracking';
import { UiModule } from '@shared/ui';
import { COOKIE_OPTIONS, CookieModule } from 'ngx-cookie';
import { AppModalsModule } from '../app/app-modals.module';
import { cookieOptionsFactory } from '../app/cookie-options.factory';
import { environment } from '../environments/environment';
import { CompatComponent } from './compat.component';
import { components } from './components';

// /!\ DO ADD ANYTHING IN THERE WITHOUT TALKING TO FRONTEND INFRA FIRST /!\
@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientXsrfModule.disable(), // no part of the app should rely on that
    CookieModule.forRoot(),
    UiModule.initialize(environment.uiConfig),
    AuthModule.initialize(environment.authConfig),
    DatastoreModule.initialize(environment.datastoreConfig),
    !environment.production
      ? StoreDevtoolsModule.instrument({ maxAge: 50 })
      : [],
    TrackingModule.initialize(environment.trackingConfig),
    AppModalsModule,
  ],
  declarations: [CompatComponent],
  providers: [
    { provide: ErrorHandler, useClass: CustomErrorHandler },
    { provide: NgModuleFactoryLoader, useClass: SystemJsNgModuleLoader },
    // This is a hack to make the CLI code splitting and ngc lazy module
    // analysis and compilation work, pending proper fix in
    // https://github.com/angular/angular-cli/issues/4541
    { provide: ROUTES, useValue: components, multi: true },
    { provide: COOKIE_OPTIONS, useFactory: cookieOptionsFactory },
  ],
  bootstrap: [CompatComponent],
})
export class CompatModule {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/es/webapp/src/compat/compat.module.ts